const SEPARATOR = '-';

export function languageFormat(language: string): string {
  const indexSeparator = language ? language.search(SEPARATOR) : 0;
  const languageSection = indexSeparator > 0 ? language.substring(0, indexSeparator) : language; 
  return languageSection ? languageSection.toUpperCase() : languageSection;
}
